
import Hero from "../components/home/hero/hero.jsx";
import Footer from "../components/footer/Footer";
import Faq from "../components/home/FAQ/faq.jsx";
import Gallery from '../components/home/gallery/gallery.jsx';
import Caresponsibility from '../components/home/responsibility/responsibility.jsx';
import Widget from '../components/home/Contact/contact.jsx';
import AboutSpirit from '../components/home/aboutspirit/aboutspirit.jsx';
import { React, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import Seo from '../components/seo/Seo';
import { paths } from '../paths';
import spiritWordmark from '../assets/Group 1000010883.png';
import spiritMark from '../assets/Spirit vector (1).png';

const STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "Event",
  name: "Spirit '26 - Annual Sports Fest, IIT Guwahati",
  description:
    "Spirit is the Annual Sports Fest of IIT Guwahati. Join the Campus Ambassador Program for Spirit '26 to lead and represent your campus.",
  startDate: "2026-01-01",
  eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
  eventStatus: "https://schema.org/EventScheduled",
  location: {
    "@type": "Place",
    name: "Indian Institute of Technology Guwahati",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Guwahati",
      addressRegion: "Assam",
      addressCountry: "IN",
    },
  },
  organizer: {
    "@type": "Organization",
    name: "Spirit, IIT Guwahati",
    url: "https://ca.spiritiitg.in",
  },
};

const Landing = () => {
  const tickerRef = useRef(null);
  const { hash } = useLocation();

  // Footer links on other pages (e.g. About Us) navigate here as "/#section" —
  // scroll to that section once it has rendered.
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
    return () => clearTimeout(t);
  }, [hash]);

  useEffect(() => {
    const ticker = tickerRef.current;
    if (!ticker) return;

    // 1. We animate to -50% because the children are duplicated 
    // to fill the space, creating a seamless loop.
    const animation = gsap.to(ticker, {
      xPercent: -50,
      duration: 20, // Lower number = faster speed
      ease: "linear", // linear is essential for constant speed
      repeat: -1,
    });

    return () => animation.kill();
  }, []);

  return (
    <div>
      <Seo
        title="Spirit '26 Campus Ambassador Program | IIT Guwahati Annual Sports Fest"
        description="Join the Campus Ambassador Program for Spirit '26, the Annual Sports Fest at IIT Guwahati. Register now to lead and represent your campus!"
        path={paths.home}
        structuredData={STRUCTURED_DATA}
      />
      <Hero />
      {/* Decorative Background Stripe */}
            <div className="relative z-20 -rotate-1 bg-white py-2 overflow-hidden -my-6 ">
              <div ref={tickerRef} className="flex items-center whitespace-nowrap w-max">
                {/* Flat list with a uniform right margin on every mark, so the gaps
                    are identical everywhere -- including at the -50% loop point. */}
                {[...Array(12)].flatMap((_, i) => [
                  <img
                    key={`wordmark-${i}`}
                    src={spiritWordmark}
                    alt="Spirit '26"
                    className="h-5 w-auto mr-12 object-contain select-none pointer-events-none"
                    draggable="false"
                  />,
                  <img
                    key={`mark-${i}`}
                    src={spiritMark}
                    alt=""
                    aria-hidden="true"
                    className="h-4 w-auto mr-12 object-contain select-none pointer-events-none"
                    draggable="false"
                  />,
                ])}
              </div>
            </div>
      {/* Each section reveals its own content on scroll (staggered fade-up).
          Gallery (GSAP pin) and Responsibility (its own row reveal) already
          animate on scroll, so they manage their own motion. */}
      <AboutSpirit />
      <Gallery />
      <Caresponsibility/>
      <Widget/>
      <Faq />
      <Footer />
    </div>
  );
};

export default Landing;
